export default __webpack_public_path__ + "static/media/automovelMobile.805cba74.png";